// Session storage utility functions

export const getFromSessionStorage = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key)
  } catch (error) {
    console.warn('Failed to read from session storage:', error)
    return null
  }
}

export const setToSessionStorage = (key: string, value: string): void => {
  try {
    sessionStorage.setItem(key, value)
  } catch (error) {
    console.warn('Failed to write to session storage:', error)
  }
}

export const removeFromSessionStorage = (key: string): void => {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    console.warn('Failed to remove from session storage:', error)
  }
}
